import { AfterViewInit, Component, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import { UIRouterModule } from '@uirouter/angular';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'mon-breadcrumb',
    imports: [
        CommonModule,
        BreadcrumbModule,
        UIRouterModule,
        TranslocoModule,
    ],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnChanges, AfterViewInit {
    @Input() model: MenuItem[] = [];
    @Input() showBreadcrumbs = true;
    @ViewChild('breadcrumbElement', { read: ElementRef }) breadcrumbElement?: ElementRef<HTMLElement>;

    items: MenuItem[] = [];

    constructor (
        private readonly renderer: Renderer2,
        private readonly translocoService: TranslocoService,
    ) {}

    ngAfterViewInit (): void {
        this.setNavAriaLabel();
    }

    ngOnChanges (changes: SimpleChanges): void {
        if (changes['model']) {
            this.buildBreadcrumbs();
            queueMicrotask(() => this.setNavAriaLabel());
        }
    }

    private setNavAriaLabel (): void {
        const breadcrumbRoot = this.breadcrumbElement?.nativeElement;
        if (!breadcrumbRoot) {
            return;
        }

        const navElement = breadcrumbRoot.querySelector('nav');
        if (!navElement) {
            return;
        }

        const ariaLabel = this.translocoService.translate('shared.breadcrumb.nav.ariaLabel');
        this.renderer.setAttribute(navElement, 'aria-label', ariaLabel);
    }

    private buildBreadcrumbs (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.items = this.model.map((item, index) => {
            const isLast = index === this.model.length - 1;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const result: any = {
                ...item,
                url: isLast ? undefined : item.url,
                styleClass: isLast ? 'p-breadcrumb-item-last' : '',
            };
            if (!isLast) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                result.command = item.command ?? (() : void => {});
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        });
    }
}
